import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);

interface DayJSProps {
  date: string | number | Date;
  fromNow?: boolean;
  format?: string;
  utc?: boolean;
}

const _getUpdate = (dayjsDate: dayjs.Dayjs, { date, format, fromNow, utc }: DayJSProps) => {
  if (fromNow) return dayjsDate.fromNow();
  else if (format) return dayjsDate.format(format);
  else return dayjsDate.toISOString();
};

export const DayJS = (props: DayJSProps) => {
  const { date, utc, fromNow } = props;
  const dayjsDate = dayjs(date, { utc });

  // const [content, setContent] = useState(_getUpdate(dayjsDate, props));
  const [content, setContent] = useState({
    formatted: _getUpdate(dayjsDate, props),
    date,
    locale: dayjsDate.format("MMM D, YYYY [at] hh:mm A"),
  });

  const update = useCallback(() => {
    // setContent(_getUpdate(dayjsDate, props));
    setContent((p) => ({
      ...p,
      formatted: _getUpdate(dayjsDate, props),
      date,
    }));
  }, [date, dayjsDate, props]);

  useEffect(() => {
    // console.log("effect", content.date, date, date !== content.date);
    if (!fromNow) return;
    if (date !== content.date) {
      update();
    }

    const intervalTimeout = setInterval(() => {
      update();
    }, 60000);

    return () => {
      clearInterval(intervalTimeout);
    };
  }, [content.date, date, update, fromNow]);

  return (
    <time dateTime={dayjsDate.valueOf().toString()} title={content.locale}>
      {content.formatted}
    </time>
  );
};

export default DayJS;
